export default __webpack_public_path__ + "static/media/feature-contact.343ec899.png";